import * as React from "react"
import { FormState } from "./constants"
import { ConnectVercel } from "./steps/ConnectVercel"
import { NewIntegration } from "./steps/NewIntegration"
import { ExistingIntegration } from "./steps/ExistingIntegration"

const getInitialStep = integration => {
  if (integration?.config?.serviceName) {
    return FormState.Existing
  }

  if (integration?.connected) {
    return FormState.New
  }

  return FormState.Connecting
}

export function VercelIntegrationWizard({
  siteId,
  siteName,
  integration,
  onSetCDNConfig,
  onCancel,
}) {
  const [step, setStep] = React.useState(getInitialStep(integration))

  const handleValidation = data => {
    onSetCDNConfig(data)
  }

  return (
    <React.Fragment>
      {step === FormState.Connecting && (
        <ConnectVercel
          siteId={siteId}
          siteName={siteName}
          onConnect={() => setStep(FormState.New)}
        />
      )}

      {step === FormState.New && (
        <NewIntegration
          siteId={siteId}
          onClose={onCancel}
          onValidate={handleValidation}
          onSwitchToExisting={() => setStep(FormState.Existing)}
        />
      )}

      {step === FormState.Existing && (
        <ExistingIntegration
          siteId={siteId}
          onClose={onCancel}
          onValidate={handleValidation}
          initialVercelProject={integration?.config?.serviceName}
          initialVercelTeam={integration?.config?.accountName}
          onSwitchToNew={() => setStep(FormState.New)}
        />
      )}
    </React.Fragment>
  )
}
